var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
import { Http, URLSearchParams } from '@angular/http';
import { timer } from 'rxjs';
import { map, switchMap, share } from 'rxjs/operators';
import { PersonalizedLocalStorageService } from 'app/notifications/personalized-local-storage.service';
var MixpanelNotificationsSource = /** @class */ (function () {
    function MixpanelNotificationsSource(httpClient, localStorageService) {
        this.httpClient = httpClient;
        this.localStorageService = localStorageService;
        this.mixpanel = window.mixpanel;
        this.mixpanel.set_config({ disable_notifications: true });
    }
    MixpanelNotificationsSource.prototype.getNotifications = function () {
        var _this = this;
        return timer(0, 10000)
            .pipe(switchMap(function () { return _this.loadNotifications(); }), share());
    };
    MixpanelNotificationsSource.prototype.markAsRead = function (notifications) {
        var e_1, _a;
        try {
            for (var notifications_1 = __values(notifications), notifications_1_1 = notifications_1.next(); !notifications_1_1.done; notifications_1_1 = notifications_1.next()) {
                var notification = notifications_1_1.value;
                this.setLocalProperty(notification, { isRead: true });
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (notifications_1_1 && !notifications_1_1.done && (_a = notifications_1.return)) _a.call(notifications_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    MixpanelNotificationsSource.prototype.close = function (notification) {
        // this.setLocalProperty(notification, { isClosed: true });
        var action = '$campaign_delivery';
        var properties = {
            campaign_id: notification.type,
            message_id: notification.id,
            message_type: 'web_inapp',
            message_subtype: 'takover'
        };
        this.mixpanel.track(action, properties);
        this.mixpanel.people.append({
            $campaigns: notification.type,
            $notifications: {
                campaign_id: notification.type,
                message_id: notification.id,
                type: 'web',
                time: new Date()
            }
        });
    };
    MixpanelNotificationsSource.prototype.setLocalProperty = function (notification, changes) {
        var e_2, _a;
        var key = this.createKey(notification);
        var props = this.localStorageService.getJson(key) || {};
        try {
            for (var _b = __values(Object.keys(changes)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var prop = _c.value;
                notification[prop] = changes[prop];
                props[prop] = changes[prop];
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        this.localStorageService.setJson(key, props);
    };
    MixpanelNotificationsSource.prototype.loadNotifications = function () {
        var _this = this;
        var params = new URLSearchParams();
        params.append('version', '2');
        params.append('lib', 'web');
        params.append('token', this.mixpanel.config.token);
        params.append('distinct_id', this.mixpanel.get_distinct_id());
        return this.httpClient
            .get('https://api.mixpanel.com/decide', { params: params })
            .pipe(map(function (response) { return _this.createNotifications(response); }));
    };
    MixpanelNotificationsSource.prototype.createNotifications = function (notificationsResponse) {
        var _this = this;
        return notificationsResponse
            .json()
            .notifications
            .map(function (notificationResponse) { return _this.createNotification(notificationResponse); })
            .filter(function (notification) { return !notification.isClosed; });
    };
    MixpanelNotificationsSource.prototype.createKey = function (notification) {
        return notification.type + "-" + notification.id;
    };
    MixpanelNotificationsSource.prototype.createNotification = function (notificationResponse) {
        var notification = {
            id: notificationResponse.message_id,
            type: notificationResponse.id,
            title: notificationResponse.title,
            body: notificationResponse.body,
            button: notificationResponse.cta,
            buttonAction: notificationResponse.cta_url,
            isRead: false,
            isClosed: false
        };
        var key = this.createKey(notification);
        var props = this.localStorageService.getJson(key) || {};
        Object.assign(notification, props);
        return notification;
    };
    return MixpanelNotificationsSource;
}());
export { MixpanelNotificationsSource };
